import { computed } from 'vue';
import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';

export const useDestinations = defineStore('destinations', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.destination_List,
    dto: 'DestinationDto',
    create: api.destination_Create,
    update: api.destination_Update,
    delete: api.destination_Delete,
    usage: api.destination_GetDestinationUsage,
    signalR: 'DestinationUpdate',
  });

  /** The default destination is the first one (lowest order) — mirrors the backend convention. */
  const defaultDestination = computed(() => globalStoreBase.loaded.value[0]);

  /** Single-destination brands hide all destination pickers and see the pre-destinations UI. */
  const hasMultiple = computed(() => globalStoreBase.loaded.value.length > 1);

  return { ...globalStoreBase, defaultDestination, hasMultiple };
});
